import { render, staticRenderFns } from "./img-retrieval.vue?vue&type=template&id=ecfc037a&scoped=true&"
import script from "./img-retrieval.vue?vue&type=script&lang=ts&"
export * from "./img-retrieval.vue?vue&type=script&lang=ts&"
import style0 from "./img-retrieval.vue?vue&type=style&index=0&id=ecfc037a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfc037a",
  null
  
)

export default component.exports